import { px, py } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';

export const BannerContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.backgroundAccentDeposit};
  border-radius: ${({ theme }) => theme.defaultBorderRadius};
  box-shadow: ${({ theme }) => theme.boxShadowLow};
  ${px('lg')}
  ${py('lg')}

  @media (min-width: ${({ theme }) => theme.mediaSm}) {
    ${px('2xl')}
  }
`;
